import { http, type HttpClient } from './core/http-client';
import type { CategoryGroup } from './models';

// The category list is public (same as on the website), so the account-level client is used.
export class CategoriesService {
  constructor(private readonly http: HttpClient) {}

  list = () => this.http.get<CategoryGroup[]>('/public/categories');
}

export const categoriesService = new CategoriesService(http);
